"use strict";
import {onFind} from "@elements/init-modules-in-scope";
import {on, findIn} from "@elements/dom-utils";

export function init () {
    onFind('.js-ajax-form', function (form) {
        let result = findIn('.js-ajax-form__result', form);

        on('fetch.ajax-form', (evt) => {
            if (result.offsetTop < window.scrollY) {
                window.scrollTo({
                    top: result.offsetTop + 40,
                    behavior: 'smooth'
                });
            }
        }, form);
    });
}